import { ContainerBloco, ContainerDinamicoEscudeiro, LinhaQuebradaInfo, TituloBloco } from "../../../Common/styles";
import { IProposta } from "../../../../../utility/IProposta";
import { comum } from "../../../../../styles/Themes/light";
import { Users } from "lucide-react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import SelectEditavel from "../../../../form/SelectEditavel";
import { CivilHearing } from "../../../../Data/CivilHearing";
import { CriminalHearing } from "../../../../Data/CriminalHearing";
import { LaborHearing } from "../../../../Data/LaborHearing";
import { AnotherHearing } from "../../../../Data/AnotherHearing";
import { ModalityAudience } from "../../../../Data/ModalityAudience";
import { ProfessionalTypeNecessary } from "../../../../Data/ProfessionalTypeNecessary";
import { useMemo } from "react";
import { mapearTituloBancoParaExibicao } from "../../../../../utils/servicoMapper";

interface BlocoAudienciaProps {
    demanda?: IProposta | null;
    loading?: boolean;
    isEditing?: boolean;
    isDisabled?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
}

const getTipoAudienciaOptions = (areaDireito: string | undefined): { value: string; label: string }[] => {
    if (!areaDireito) {
        return [];
    }

    const areaNormalizada = areaDireito.toLowerCase().trim();
    
    if (areaNormalizada.includes('cível') || areaNormalizada.includes('civil') || areaNormalizada === 'audiência cível') {
        return CivilHearing;
    }
    
    if (areaNormalizada.includes('penal') || areaNormalizada === 'audiência penal') {
        return CriminalHearing;
    }
    
    if (areaNormalizada.includes('trabalhista') || areaNormalizada === 'audiência trabalhista') {
        return LaborHearing;
    }
    
    const outrasAudienciasVariants = [
        'outras audiências',
        'outras audiencias',
        'outros presencial',
        'outros virtual'
    ];
    
    if (outrasAudienciasVariants.some(variant => areaNormalizada.includes(variant))) {
        return AnotherHearing;
    }
    
    return [];
};

export default function BlocoAudiencia({demanda, loading = false, isEditing = false, isDisabled = false, onChange, onBlur, errors}: BlocoAudienciaProps) {

    const areaDireitoMapeada = useMemo(() => {
        return mapearTituloBancoParaExibicao(demanda?.titulo_servico);
    }, [demanda?.titulo_servico]);

    const tipoAudienciaOptions = useMemo(() => {
        return getTipoAudienciaOptions(areaDireitoMapeada);
    }, [areaDireitoMapeada]);

    const handleTipoAudienciaChange = (value: string) => {
        if (onChange) {
            onChange('tipo_audiencia', value);
        }
    };

    const handleModalidadeChange = (value: string) => {
        if (onChange) {
            onChange('modalidade', value);
            if (onBlur) {
                setTimeout(() => {
                    onBlur('modalidade');
                    onBlur('endereco_virtual');
                }, 100);
            }
        }
    };

    const handleProfissionalChange = (value: string) => {
        if (onChange) {
            onChange('profissional_necessario', value);
        }
    };

    return (
        <ContainerBloco>
            {loading ? (
                <>
                    <Skeleton height={24} width="50%" style={{ marginBottom: '12px' }} />
                    <ContainerDinamicoEscudeiro>
                        <Skeleton height={60} width="100%" style={{ marginBottom: '12px' }} />
                        <Skeleton height={60} width="100%" style={{ marginBottom: '12px' }} />
                        <Skeleton height={60} width="100%" />
                    </ContainerDinamicoEscudeiro>
                </>
            ) : (
                <>
                <TituloBloco>
                    <Users size={16} color={comum.colors.primaryRed400}/>
                    Audiência
                </TituloBloco>
                    <LinhaQuebradaInfo>
                        <span className="label">
                        Tipo de Audiência
                    </span>
                        <SelectEditavel
                            value={demanda?.tipo_audiencia}
                            onChange={handleTipoAudienciaChange}
                            onBlur={() => onBlur && onBlur('tipo_audiencia')}
                            isEditing={isEditing}
                            disabled={isDisabled}
                            options={tipoAudienciaOptions}
                            placeholder="Selecionar"
                            error={errors?.tipo_audiencia}
                        />
                </LinhaQuebradaInfo>
                <LinhaQuebradaInfo>
                    <span className="label">
                        Modalidade
                    </span>
                        <SelectEditavel
                            value={demanda?.modalidade}
                            onChange={handleModalidadeChange}
                            onBlur={() => onBlur && onBlur('modalidade')}
                            isEditing={isEditing}
                            disabled={isDisabled}
                            options={ModalityAudience}
                            placeholder="Selecionar"
                            error={errors?.modalidade}
                        />
                </LinhaQuebradaInfo>
                <LinhaQuebradaInfo>
                    <span className="label">
                        Profissional Necessário
                    </span>
                        <SelectEditavel
                            value={demanda?.profissional_necessario}
                            onChange={handleProfissionalChange}
                            onBlur={() => onBlur && onBlur('profissional_necessario')}
                            isEditing={isEditing}
                            disabled={isDisabled}
                            options={ProfessionalTypeNecessary}
                            placeholder="Selecionar"
                            error={errors?.profissional_necessario}
                        />
                    </LinhaQuebradaInfo>
                </>
            )}
        </ContainerBloco>
    )
}

